import * as React from "react";
import PropTypes from "prop-types";
import moment from "moment";

export default class DateTime extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.string, // ISO-8601 or RFC1123 date string
      PropTypes.number, // Unix Timestamp
    ]).isRequired,
    relative: PropTypes.bool,
    natural: PropTypes.bool,
    format: PropTypes.string,
  };

  static defaultProps = {
    format: "dddd, MMMM D, YYYY h:mm A",
  };

  render() {
    const { value, relative, natural, format } = this.props;

    let content;
    if (natural) {
      content = moment(value).format("[on] dddd, MMMM D, YYYY [at] h:mm A");
    } else if (relative) {
      content = moment(value).fromNow();
    } else if (format) {
      content = moment(value).format(format);
    } else {
      content = null;
    }

    return <span data-component-name="DateTime">{content}</span>;
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/DateTime.jsx